module.exports = __webpack_public_path__ + "img/login-cont-img.8a1aa543.png";